export default __webpack_public_path__ + "locales/ja-JP/ArchiveDialog.json?hash=ca34771fb68a125de1b8c9f248f33c98";